export default {
  name: 'dicom-plus-modal-tab-mamografia',
  inject: ['dicomPlusModal'],
  computed: {
    m() {
      return this.dicomPlusModal
    }
  }
}
